import { jwtDecode } from 'jwt-decode';
import { Redirect, Route } from 'react-router-dom';

function PrivateRoute({ children, ...rest }) {
  const authorized = () => {
    const token = localStorage.getItem('mapyourmove_token')
    if (token == null) return false;
    try{
      const decoded = jwtDecode(token)
      if (decoded.exp * 1000 < new Date().getTime()) return false;
    }
    catch {
      localStorage.removeItem('mapyourmove_name')
      localStorage.removeItem('mapyourmove_token')
      return false
    }
    return true;
  }
  return (
    <Route
      { ...rest }
      render={({ location }) =>
        authorized() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;